import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SalesContractFolderFixedAssetLinkContainerModel } from "../../../../../../models/aggregates/erp/sales-contract";
import {
    BaseApiTemplateService,
    Core2Config
} from "../../shared";

@Injectable({ providedIn: "root" })
export class SalesContractFolderFixedAssetLinkService extends BaseApiTemplateService<SalesContractFolderFixedAssetLinkContainerModel> {
  static readonly SALES_CONTRACT_FOLDER_HDR_FIXED_ASSET_LINK_SUBPATH =
    "sales-contract-folder-to-fixed-asset-register-links/";

  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.FI_PREFIX +
      SalesContractFolderFixedAssetLinkService.SALES_CONTRACT_FOLDER_HDR_FIXED_ASSET_LINK_SUBPATH +
      BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.FI_PREFIX +
      SalesContractFolderFixedAssetLinkService.SALES_CONTRACT_FOLDER_HDR_FIXED_ASSET_LINK_SUBPATH +
      BaseApiTemplateService.BACKOFFICE_EP;
    this.httpClient = http;
  }
}
